// Shopify Preictive Search - https://shopify.dev/docs/themes/navigation-search/search/predictive-search
class PredictiveSearch extends HTMLElement {
    constructor() {
        super();

        this.input = this.querySelector('input[type="search"]');
        this.predictiveSearchResults = this.querySelector('#predictive-search');
        this.searchOverlay = document.querySelector('#search-overlay');
        this.resourcesType = this.input.dataset.resourcesType;
        this.mobileDisable = this.input.dataset.mobileDisable;

        if (this.mobileDisable == 'false') {
            this.input.addEventListener('input', this.debounce((event) => {
                this.onChange(event);
            }, 300).bind(this));
        }
    }

    onChange() {
        const searchTerm = this.input.value.trim();

        if (!searchTerm.length) {
            this.close();
            return;
        }

        this.getSearchResults(searchTerm, this.resourcesType);
    }

    getSearchResults(searchTerm, resourcesType) {
        fetch(`/search/suggest?q=${searchTerm}&resources[options][fields]=body,product_type,tag,title,variants.barcode,variants.sku,variants.title,vendor,body,author&resources[type]=${resourcesType}&resources[options][unavailable_products]=last&resources[limit]=10&section_id=predictive-search`)
            .then((response) => {
                if (!response.ok) {
                    var error = new Error(response.status);
                    this.close();
                    throw error;
                }

                return response.text();
            })
            .then((text) => {
                const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
                this.predictiveSearchResults.innerHTML = resultsMarkup;
                this.open();
            })
            .catch((error) => {
                this.close();
                throw error;
            });
    }

    open() {
        this.predictiveSearchResults.style.display = 'block';
        this.searchOverlay.style.display = 'block';

    }

    close() {
        this.predictiveSearchResults.style.display = 'none';
        this.searchOverlay.style.display = 'none';

    }

    debounce(fn, wait) {
        let t;
        return (...args) => {
            clearTimeout(t);
            t = setTimeout(() => fn.apply(this, args), wait);
        };
    }

}

customElements.define('iam-predictive-search', PredictiveSearch);

